import {
  ApiService, AuthService,
  BaseUrlService, BbwcWidgetService,
  EnvironmentService,
  HttpHeaderService,
  HttpManifestService,
  HttpService,
  UrlService,
} from '@ec/common';

const PRE_LOGIN__CLASS = 'bbwclp-prelogin';
const POST_LOGIN__CLASS = 'bbwclp-postlogin';

const ABOUT_PAGE_ID = 'about';
const TOP_BAR_ID = 'ec-micro-top-bar';
const BBWW_LANDING_PAGE_ID = 'bbwc-landing-page';
const BBWW_GLOBAL_HEADER_ID = 'bbwcgh-container';
const MAIN_CONTAINER_ID = 'containerId';
const ALL_COMPONENT_IDS = [
  ABOUT_PAGE_ID,
  TOP_BAR_ID,
  BBWW_LANDING_PAGE_ID,
  BBWW_GLOBAL_HEADER_ID,
  MAIN_CONTAINER_ID,
];

const PRE_LOGIN_OFFSET = 10;
const POST_LOGIN_OFFSET = 150;

const LOG_IN_PATH = `login?redirect_uri=`;

export class PreLoginService {

  static async init() {
    const httpRequestService = new HttpService();
    const environmentService = new EnvironmentService( window.location );
    const baseUrlService = new BaseUrlService( window, environmentService );
    const httpHeaderService = new HttpHeaderService( window );
    const manifestService = new HttpManifestService( baseUrlService, httpRequestService, environmentService );
    const masterManifest = await manifestService.getMasterManifestJson();
    const urlService = new UrlService( window );
    const appManifest = manifestService.getCurrentAppManifest( masterManifest );
    const isExternal = !appManifest?.isInternal;
    const apiService = new ApiService( environmentService, httpHeaderService, httpRequestService, isExternal );
    const bbwcWidgetService = new BbwcWidgetService( window, apiService );
    const authService = new AuthService( window, environmentService, baseUrlService, apiService, urlService );

    await bbwcWidgetService.createWidget( 'landing-page', 'containerId' );

    if ( await authService.isLoggedIn() ) {
      await PreLoginService.initPostLoginExperience();
    } else {
      // @ts-ignore
      const apiPath = authService.getApiPath( LOG_IN_PATH );
      // @ts-ignore
      const logInLink = `${ apiPath }${ authService.getRedirectUrl( '' ) }`;
      PreLoginService.initPreLoginExperience( logInLink );
    }
  };


  private static setClasses( componentIds: string[], className: string ) {
    const missingComponentIds: string[] = [];

    componentIds.forEach( componentId => {
      const el = document.getElementById( componentId );
      if ( el ) {
        el.classList.add( className );
      } else {
        missingComponentIds.push( componentId );
      }

      if ( missingComponentIds.length ) {
        setTimeout( () => PreLoginService.setClasses( missingComponentIds, className ), 500 );
      }

    } );
  };

  private static updateWidget( config: { [ key: string ]: string } ) {
    const intervalRef = setInterval( () => {
      // @ts-ignore
      const bbwclp = window[ 'bbwclp' ];
      if ( bbwclp && bbwclp.forceUpdate ) {
        bbwclp.forceUpdate( config );
        clearInterval( intervalRef );
      }
    }, 100 );
  };

  private static getWidgetConfig(): Promise<{ [ key: string ]: any }> {
    let maxAttempts = 500;
    let attempts = 0;
    const promise: Promise<{ [ key: string ]: any }> = new Promise( ( resolve, reject ) => {
      const intervalRef = setInterval( () => {
        attempts++;
        // @ts-ignore
        const bbwclp = window[ 'bbwclp' ];
        if ( bbwclp && bbwclp.state ) {
          resolve( bbwclp.state );
          clearInterval( intervalRef );
        } else if ( attempts > maxAttempts ) {
          reject( 'Max number of attempts reached.' );
        }
      }, 100 );
    } );

    return promise;
  }

  private static async initPreLoginExperience( logInLink: string ) {
    const productSignInRoute = logInLink;
    PreLoginService.setClasses( ALL_COMPONENT_IDS, PRE_LOGIN__CLASS );
    const currentConfig = await this.getWidgetConfig();
    await PreLoginService.updateWidget( { ...currentConfig, productSignInRoute } );
    this.updateWidget( { aboutPage: { ...currentConfig.aboutPage, showLogin: true, offset: PRE_LOGIN_OFFSET } } );
  };


  private static async initPostLoginExperience() {
    PreLoginService.setClasses( ALL_COMPONENT_IDS, POST_LOGIN__CLASS );
    const currentConfig = await this.getWidgetConfig();
    this.updateWidget( { aboutPage: { ...currentConfig.aboutPage, showLogin: false, offset: POST_LOGIN_OFFSET } } );
  };
}
